// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Function to get page name from path (keep from previous step)
    const getPageName = (pathname) => {
        if (pathname === '/') return 'Home';
        if (pathname.startsWith('/blog/')) return 'Blog Post';
        const name = pathname.substring(1).charAt(0).toUpperCase() + pathname.substring(2);
        return name.split('/')[0];
    };

    const currentPageName = getPageName(location.pathname);

    // Close menu on resize (keep from previous step)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768 && isMenuOpen) {
                setIsMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMenuOpen]);

    return (
        <header className="header">
            {/* Add class to nav when menu is open for animation trigger */}
            <nav className={`nav ${isMenuOpen ? 'mobile-menu-open' : ''}`} role="navigation" aria-label="Main navigation">
                {/* Left: Home Icon */}
                <div className="nav-left">
                    <NavLink to="/" aria-label="Go to homepage" onClick={() => setIsMenuOpen(false)}>
                        <img
                            src="/images/qcat-icon-256.png"
                            alt="Home"
                            width="65"
                            height="65"
                            className="header-icon"
                        />
                    </NavLink>
                </div>

                {/* Center: Page Title (Mobile Only) */}
                <span className="mobile-page-title mobile-only">{currentPageName}</span>

                {/* Links Container (Hidden on mobile unless menu open) */}
                <div className={`nav-center ${isMenuOpen ? 'mobile-visible' : 'mobile-hidden'}`}>
                    {/* Links remain the same */}
                    <NavLink to="/games" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={isMenuOpen ? toggleMenu : undefined}>Games</NavLink>
                    <NavLink to="/blog" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={isMenuOpen ? toggleMenu : undefined}>Blog</NavLink>
                    <NavLink to="/store" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={isMenuOpen ? toggleMenu : undefined}>Store</NavLink>
                    <NavLink to="/contacts" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} onClick={isMenuOpen ? toggleMenu : undefined}>Contacts</NavLink>
                </div>

                {/* Hamburger Button (Mobile Only) - with CSS bars */}
                <button
                    className="hamburger-button mobile-only"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation menu"
                    aria-expanded={isMenuOpen}
                >
                    {/* Revert back to spans for CSS bars */}
                    <span className="hamburger-icon-bar"></span>
                    <span className="hamburger-icon-bar"></span>
                    <span className="hamburger-icon-bar"></span>
                </button>
            </nav>
        </header>
    );
};

export default Header;